/**
 * Cart variables
 */
export default {
    /**
     * Items on cart (Course ids)
     */
    items: [],

    /**
     * Total quantity
     */
    totalQuantity: 0,

    /**
     * Total price (sum)
     */
    totalPrice: 0
}